import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, Validators } from "@angular/forms";
import { ReviewService } from "src/app/review/review.service";
import { ReviewCardComponent } from "../review-card.component";
import { ReviewFilter } from "src/app/review/models/review-filter";
import { takeUntil } from "rxjs/operators";
import * as moment from "moment";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { AppInjector } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";

@Component({
  selector: "date-filter-review",
  templateUrl: "./date-filter-review.component.html",
  styleUrls: ["./date-filter-review.component.scss"],
})
export class DateFilterReviewComponent extends ReviewCardComponent implements OnInit {
  form: UntypedFormGroup;
  isOk4Load: boolean = false;
  DateNow: string;
  DateYesterday: string;
  limitDateChanges: boolean = false;
  protected sts: ShowToastrService;
  @Input() hasIncludeTime: boolean = false;
  @Input() showAllDays: boolean = false;
  constructor(service: ReviewService, private fb: UntypedFormBuilder) {
    super(service);
    this.sts = AppInjector.get(ShowToastrService);
    this.name = "default-date-filter";
  }

  ngOnInit() {
    this.createForm();
    super.ngOnInit();

    this.service.startDate$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.form) {
        this.form.controls["StartDate"].setValue(x, { emitEvent: false });
        this.service.startDate = x;
        this.isOk4Load = true;
      }
    });
    this.service.endDate$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && this.form) {
        this.form.controls["EndDate"].setValue(x, { emitEvent: false });
        this.service.endDate = x;
        this.isOk4Load = true;
      }
    });

    this.form
      .get("StartDate")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((s) => {
        if (s) this.applyFilter();
      });
    this.form
      .get("EndDate")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((s) => {
        if (s) this.applyFilter();
      });
    this.form
      .get("StartTime")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((s) => {
        if (s) this.applyFilter();
      });
    this.form
      .get("EndTime")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((s) => {
        if (s) this.applyFilter();
      });
  }

  createForm() {
    this.form = this.fb.group({
      StartDate: this.service.startDate,
      EndDate: this.service.endDate,
      StartTime: this.service.startTime,
      EndTime: this.service.endTime,
      includeTime: this.service.includeTime,
    });
  }

  private formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${day}`;
  }

  applyFilter() {
    const m = moment();
    const today = m.locale("fa").format("YYYY/MM/DD");
    const yesterday = m.locale("fa").subtract(1, "days").format("YYYY/MM/DD");
    const controls = this.form.controls;

    if (!this.showAllDays && controls["StartDate"].value && controls["EndDate"].value) {
      const startDateFormatted = this.formatDateToYYYYMMDD(new Date(controls["StartDate"].value));
      const endDateFormatted = this.formatDateToYYYYMMDD(new Date(controls["EndDate"].value));

      if (startDateFormatted > today || startDateFormatted < yesterday || endDateFormatted > today || endDateFormatted < yesterday) {
        this.sts.showDialog("کاربر گرامی شما تنها مجاز به انتخاب تاریخ دیروز و امروز هستید", "عدم دسترسی");
        controls["StartDate"].setValue(new Date(), { emitEvent: false });
        controls["EndDate"].setValue(new Date(), { emitEvent: false });
      }
    }

    const startDateTime = this.appendTimeToDate(controls["StartDate"].value, this.service.includeTime ? controls["StartTime"].value : "00:00");
    const endDateTime = this.appendTimeToDate(controls["EndDate"].value, this.service.includeTime ? controls["EndTime"].value : "00:00");

    this.service.startDate = controls["StartDate"].value;
    this.service.endDate = controls["EndDate"].value;
    this.service.endTime = controls["EndTime"].value;
    this.service.startTime = controls["StartTime"].value;
    this.service.startDate$.next(this.service.startDate);
    this.service.endDate$.next(this.service.endDate);

    if (`${startDateTime}` !== "Invalid Date" && `${endDateTime}` !== "Invalid Date") {
      this.service.applyDateTimeFilter(this.name, startDateTime, endDateTime, this.service.includeTime);
    }
  }

  protected loadItems(filter: ReviewFilter): void {}

  private appendTimeToDate(date: string, time: string) {
    const dateTime = new Date(date);
    const [hours, minutes] = time
      .toString()
      .split(":")
      .map((x: string) => parseInt(x));

    dateTime.setHours(hours, minutes, 0, 0);
    return dateTime;
  }
}
